const Loader = ({ progress }) => (
    <div className="loader-container">
      <div className="progress-bar">
        <div className="progress-bar-fill" style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
  
  export default Loader;
  